import { Table, Typography } from "antd"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _AppTable(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, title, headers, rows, pagination, onChange } = props

    const { Text, Title } = Typography

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <Title level={2}>{title}</Title>
            <Table
                dataSource={rows}
                rowKey={(i) => i.id ?? i.key}
                columns={headers}
                pagination={{
                    position: ["bottom", "none"],
                    showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total}`,
                    hideOnSinglePage: true,
                    ...pagination,
                }}
                onChange={onChange}
            />
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_AppTable.propTypes = {
    className: PropTypes.string.isRequired,
    title: PropTypes.string,
    headers: PropTypes.array,
    rows: PropTypes.array.isRequired,
}

_AppTable.defaultProps = {}

// ----------------------------------------------------------------------------

const AppTable = styled(_AppTable)`
    & {
        width: 100%;
        background-color: ${(props) => props.theme.colors.light};
        border-radius: 20px;
        box-shadow: 0px 5px 20px rgba(146, 146, 157, 0.05);
        padding: ${(props) => props.theme.spacing.bigPadding} 37px
            ${(props) => props.theme.spacing.bigPadding} 51px;
        margin-bottom: 56px;

        &:last-child {
            margin-bottom: 0;
        }
        h2 {
            font-size: ${(props) => props.theme.font.title3.size};
            line-height: ${(props) => props.theme.font.title3.heigth};
            padding-bottom: ${(props) => props.theme.spacing.padding};
            margin: 0;
        }
        table {
            width: 100%;
            border-spacing: 0;
            thead {
                background-color: ${(props) => props.theme.colors.dark100};
                tr {
                    th {
                        text-align: left;
                        padding: 12px 23px 13px;
                        text-transform: uppercase;
                        font-size: ${(props) => props.theme.font.table.head};
                        font-weight: ${(props) =>
                            props.theme.font.weight.medium};
                        &:first-child {
                            border-radius: ${(props) =>
                                    props.theme.spacing.radius}
                                0 0 ${(props) => props.theme.spacing.radius};
                        }
                        &:last-child {
                            border-radius: 0
                                ${(props) => props.theme.spacing.radius}
                                ${(props) => props.theme.spacing.radius} 0;
                        }
                    }
                }
            }
            tbody {
                tr {
                    td {
                        padding: 25px 23px 17px;
                        border-bottom: 1px solid
                            ${(props) => props.theme.colors.tableBorder};
                    }
                    &:last-child {
                        td {
                            border-bottom: 0;
                        }
                    }
                }
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default AppTable
